export type State = {
  loading: boolean;
  navigationLoading: boolean;
  requestsPending: number;
};

const objState = {
  loading: false,
  navigationLoading: false,
  requestsPending: 0
};

export const state: State = objState;
